import React from 'react';
import {Box, IconButton, Modal, TextField, Typography} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import FilledButton from "../../../components/buttons/FilledButton";
import {observer} from "mobx-react";

function DeleteOrderModal({feature}) {
    const handleClose = () => {
        feature.setIsDeletingOrder(false);
    };

    const handleConfirm = () => {
        feature.setIsDeletingOrder(false);
        feature.deleteOrder()
    };

    return (
        <Modal open={feature.isDeletingOrder} onClose={handleClose}>
            <Box sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: 450,
                p: 4,
                textAlign: 'center',
                borderRadius: '8px',
                backgroundColor: 'background.paper',
                "@media (max-width: 768px)": {
                    width: "95%",
                },
            }}>
                <IconButton onClick={handleClose} sx={{position: 'absolute', top: 5, right: 5}}>
                    <CloseIcon/>
                </IconButton>

                <Typography variant="body1" gutterBottom sx={{fontSize: '18px'}}>
                    ¿Está seguro que desea borrar el pedido?
                </Typography>

                <Box sx={{mt: 2, textAlign: 'left'}}>
                    <TextField
                        label="Observaciones"
                        value={feature.observations}
                        onChange={(e) => {
                            feature.setObservations(e.target.value);
                        }}
                        multiline
                        fullWidth
                        required
                        minRows={3}
                        maxRows={5}
                    />
                </Box>

                <Box sx={{mt: 2, display: 'flex', justifyContent: 'space-around'}}>
                    <FilledButton
                        onClick={handleConfirm}
                        disabled={!feature.hasObservations()}
                    >
                        Si, borrar pedido
                    </FilledButton>
                    <FilledButton onClick={handleClose}>
                        No, cancelar
                    </FilledButton>
                </Box>
            </Box>
        </Modal>
    );
}

export default observer(DeleteOrderModal);
